export const leftFillNum = (num: number | string, targetLength: number) =>
    typeof String.prototype.padStart !== 'undefined' ? num?.toString().padStart(targetLength, '0') : `0${num}`.slice(-2);

export const randomId = (prefix: string = '') => prefix + '_' + Math.random().toString(36).substring(2, 10);
